import React from 'react'
import { ModalProps } from '../Modal/Modal'
import { PortalModal } from '~/components/shared/PortalModal'

export interface ISideModalProps extends Omit<ModalProps, 'show' | 'onClose'> {
  children: React.ReactNode
  openSlideModal: boolean
  setOpenSlideModal: (newState: boolean) => void
}

export const SideModal: React.FC<ISideModalProps> = ({
  openSlideModal,
  setOpenSlideModal,
  children,
  ...modalProps
}: ISideModalProps): JSX.Element => {
  return (
    <PortalModal
      show={openSlideModal}
      onClose={() => setOpenSlideModal(false)}
      useMask={false}
      size={'sideMenu'}
      customWidth={521}
      customFullscreenCloseButton={true}
      {...modalProps}
    >
      {children}
    </PortalModal>
  )
}
